import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { GOOGLE_FORM_URL } from "@/constants/links";

export default function LeadForm() {
  return (
    <section
      id="contact"
      className="relative py-24 md:py-40 bg-[#0a192f] text-white overflow-hidden"
      data-testid="contact-section"
    >
      <div className="grain-dark absolute inset-0" aria-hidden="true" />
      <div className="relative mx-auto max-w-[1440px] px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5">
            <span
              className="font-label text-[11px] text-[#00A3FF]"
              style={{ letterSpacing: "0.28em" }}
            >
              CH · 06 / Boarding Pass
            </span>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl tracking-[-0.025em] leading-[0.98] mt-6">
              Book your free{" "}
              <span className="italic font-normal text-[#00A3FF]">
                consultation.
              </span>
            </h2>
            <p className="text-white/70 font-body mt-8 max-w-md leading-relaxed">
              Tell us where you want to go and when. A senior advisor will call
              you back within 24 hours to walk through your profile.
            </p>

            <div className="mt-14 space-y-6 max-w-sm">
              <div className="grid grid-cols-[80px_1fr] gap-4 items-start">
                <span className="font-mono-tech text-[10px] text-white/50 tracking-widest">
                  BAREILLY
                </span>
                <div className="text-sm text-white/85">
                  207/205 Gher Annu Khan Aonla,
                  <br />
                  Bareilly 243301, India
                </div>
              </div>
              <div className="grid grid-cols-[80px_1fr] gap-4 items-start">
                <span className="font-mono-tech text-[10px] text-white/50 tracking-widest">
                  POLAND
                </span>
                <div className="text-sm text-white/85">
                  Warsaw,
                  <br />
                  Poland, Europe
                </div>
              </div>
              <div className="grid grid-cols-[80px_1fr] gap-4 items-start">
                <span className="font-mono-tech text-[10px] text-white/50 tracking-widest">
                  EMAIL
                </span>
                <div className="text-sm text-white/85">
                  <a
                    href="mailto:infoflyedu@gmail.com"
                    className="hover:text-[#00A3FF] transition-colors"
                    data-testid="contact-email-link"
                  >
                    infoflyedu@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="md:col-span-7 bg-white/[0.03] border border-white/10 backdrop-blur-sm p-8 md:p-12 flex flex-col justify-between gap-10"
            data-testid="lead-form"
          >
            <div>
              <div className="font-mono-tech text-[10px] tracking-widest text-white/50 uppercase mb-6">
                01 · Reserve your seat
              </div>
              <p className="font-display text-2xl md:text-4xl leading-tight tracking-[-0.02em] text-white">
                One short form. One call back.{" "}
                <span className="italic font-normal text-[#00A3FF]">
                  One step closer to departure.
                </span>
              </p>
              <p className="text-white/60 font-body mt-6 max-w-md leading-relaxed">
                Click below to open our consultation form. Share your target
                country, intake, and contact details — it takes under two
                minutes.
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-4 justify-between">
              <span className="font-mono-tech text-[10px] text-white/40 tracking-widest">
                STATUS · READY FOR TAKEOFF
              </span>
              <a
                href={GOOGLE_FORM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-pill btn-sky"
                data-testid="lead-submit"
              >
                Book Free Consultation
                <ArrowUpRight size={16} />
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
